import { post, put, del, get } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR from 'swr'
import { handleApiResponse } from './api_util';
import mutateClearCache from './mutateclearcache.js';

async function deleteOrg(orgID){
  const payload={
    apiName: 'LivisiblyOrgApi',
    path: `orgs/${orgID}`,
  }
  const restOperation = del(payload);
  const response = await restOperation.response;
  return processResponse(response)

}

async function getOrgs(){

  const payload={
    apiName: 'LivisiblyOrgApi',
    path: 'orgs'

  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  return processResponse(response)
}

async function getOrg(orgID){
  const payload={
    apiName: 'LivisiblyOrgApi',
    path: `orgs/${orgID}`
  }

  const restOperation = get(payload);


  const response = await restOperation.response;
  return processResponse(response)
}

async function createOrg(orgData){

    console.log(`entered createOrg orgData: ${JSON.stringify(orgData)}`)
    const payload={
        apiName: 'LivisiblyOrgApi',
        path: 'orgs',
        options: {
          body: {
            org_data: orgData,
          }
        }
      }
      console.log(`posting payload: ${JSON.stringify(payload)}`)
      const restOperation = post(payload);


      const response = await restOperation.response;
      return processResponse(response)
}

async function updateOrg(orgData){
  const payload={
      apiName: 'LivisiblyOrgApi',
      path: 'orgs',
      options: {
        body: {
          org_data: orgData,
        }
      }
    }

    const restOperation = put(payload);


    const response = await restOperation.response;
    return processResponse(response)
}

// Create orgs
export function useCreateOrg() {
  return async (orgData) => {
    try {
      const response = await createOrg(orgData);
      handleApiResponse('ORGS','orgID',response, 'create');
      // don't remove cache because we don't want to assign the user to the org automatically anymore
      // if (response.summary.successfulItems > 0) {
      //   mutateClearCache()
      // }
      return response;
    } catch (error) {
      console.error('Error creating org:', error);
      throw error;
    }
  };
}

export function useGetOrg(orgID, shouldFetch=true){
  const result = useSWR(
    shouldFetch ? ['ORGS', orgID] : null,
    ([path, orgID]) => getOrg(orgID)
  );
  return result;
}

export function useGetOrgs(shouldFetch=true){
  const result = useSWR(
    shouldFetch ? 'ORGS' : null,
    (path) => getOrgs()
  );
  return result;
}

// Update orgs
export function useUpdateOrg() {
  return async (updatedData) => {
    try {
      const response = await updateOrg(updatedData);
      return handleApiResponse('ORGS','orgID',response, 'update');
    } catch (error) {
      console.error('Error updating org:', error);
      throw error;
    }
  };
}


// Delete orgs
export function useDeleteOrg() {
  return async (orgID) => {
    try {
      const response = await deleteOrg(orgID);
      return handleApiResponse('ORGS','orgID',response, 'delete');
    } catch (error) {
      console.error('Error deleting org:', error);
      throw error;
    }
  };
}